import { fetchViewOffer, TViewOfferResponse } from '../../repositories/cian-chat-bot/v1/view-offer';
import { IApplicationContext } from '../../types/applicationContext';

const DEGRADATION_TELEMETRY_KEY = 'degradation.chatbotViewOffer';
export async function fetchOfferView(
  { httpApi, logger, telemetry }: IApplicationContext,
  offerId: number,
): Promise<void> {
  try {
    const { statusCode, response }: TViewOfferResponse = await fetchViewOffer({
      httpApi,
      parameters: {
        offerId,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);
      logger.warning('Невалидный ответ от сервера', {
        domain: 'src/shared/services/chatbotFeedback/fetchOfferView/fetchOfferView.ts',
        statusCode,
        message: response.message || 'Неизвестная ошибка',
        errors: JSON.stringify(response?.errors),
      });
    }
  } catch (error) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(error, {
      domain: 'src/shared/services/chatbotFeedback/fetchOfferView/fetchOfferView.ts',
      message: 'Не удалось передать переход к объявлению',
    });
  }
}
